import { useQuery } from '@tanstack/react-query'
import api from '~utils/http'
import { APP_QUERY_KEYS } from './query-keys'

// 펫 몸무게 기록 (GET /app/pets/{id}/weights/, 최신순). value 는 DRF Decimal 이라 문자열
export type PetWeightRecord = Readonly<{
  id: number
  value: string | number
  unit: string
  date: string
}>

/**
 * 펫의 최신 몸무게 (문진 v2 숫자 질문 prefill_from 'pet.weight', DRT-7186).
 * SmartThings 펫 프로필에는 몸무게가 없어 기록이 없으면 null 이고, 실패해도 질문은 그대로 보인다.
 */
const usePetLatestWeight = (petId: number | null | undefined, enabled: boolean) =>
  useQuery({
    queryKey: APP_QUERY_KEYS.petLatestWeight(petId ?? 0),
    queryFn: async (): Promise<PetWeightRecord | null> =>
      (
        await api.get<PetWeightRecord[]>(`/app/pets/${petId}/weights/`, {
          withCredentials: true,
        })
      ).data[0] ?? null,
    enabled: enabled && !!petId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })

export default usePetLatestWeight
